(() => {
  if (customElements.get('pbh-counter')) return;

  class PBHCounter extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialised === 'true') return;

      const numberEl = this.querySelector('.pbh-stat__number');
      if (!numberEl) return;

      this.dataset.initialised = 'true';

      const targetValue = Number.parseFloat(numberEl.dataset.value);
      const suffix = numberEl.dataset.suffix || '';
      const duration = Number.parseInt(this.dataset.duration || '1600', 10);
      const shouldAnimate = this.dataset.animate !== 'false';
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!shouldAnimate || prefersReducedMotion || Number.isNaN(targetValue)) {
        if (!Number.isNaN(targetValue)) {
          this.#setDisplay(targetValue, suffix);
        }
        return;
      }

      this.#observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.#observer.unobserve(this);
            this.#setDisplay(0, suffix);
            this.#animateCount(targetValue, suffix, duration);
          });
        },
        { rootMargin: '0px 0px -50px 0px' }
      );

      this.#observer.observe(this);
    }

    disconnectedCallback() {
      if (this.#observer) {
        this.#observer.disconnect();
        this.#observer = null;
      }

      if (this.#animationFrame) {
        cancelAnimationFrame(this.#animationFrame);
        this.#animationFrame = null;
      }
    }

    #observer = null;
    #animationFrame = null;

    #setDisplay(value, suffix) {
      const numberEl = this.querySelector('.pbh-stat__number');
      const suffixEl = this.querySelector('.pbh-stat__suffix');
      if (!numberEl) return;

      const rounded = Math.round(value);
      numberEl.textContent = `${rounded}`;

      if (suffixEl) {
        suffixEl.textContent = suffix;
      } else if (suffix) {
        numberEl.textContent = `${rounded}${suffix}`;
      }
    }

    #animateCount(target, suffix, duration) {
      const startTime = performance.now();

      const tick = (now) => {
        const progress = Math.min((now - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        this.#setDisplay(target * eased, suffix);

        if (progress < 1) {
          this.#animationFrame = requestAnimationFrame(tick);
        } else {
          this.#setDisplay(target, suffix);
          this.#animationFrame = null;
        }
      };

      this.#animationFrame = requestAnimationFrame(tick);
    }
  }

  customElements.define('pbh-counter', PBHCounter);
})();
